export default {"src":"/_next/static/media/crv.51b36f3f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};